import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
export { getBroadcastChannel };
var FakeChannel = /*#__PURE__*/function () {
  function FakeChannel(_name) {
    _classCallCheck(this, FakeChannel);
    _defineProperty(this, "onmessage", void 0);
  }
  _createClass(FakeChannel, [{
    key: "postMessage",
    value: function postMessage(_message) {}
  }]);
  return FakeChannel;
}();
var channel = typeof BroadcastChannel !== 'undefined' ? new BroadcastChannel('oneauth-sdk') : new FakeChannel('oneauth-sdk');
function getBroadcastChannel() {
  return channel;
}